<template>
  <!-- Navbar -->
  <nav class="navbar navbar-expand-lg blur top-0 z-index-3  start-0 end-0">
    <div class="container-fluid">
      <a class="navbar-brand font-weight-bolder ms-lg-0 ms-3 " href="/meta">
        <img src="@/assets/img/logo-ct-dark.png" alt="Meta" width="37">
      </a>
      <button class="navbar-toggler shadow-none ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#navigation"
        aria-controls="navigation" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon mt-2">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </span>
      </button>
      <div class="collapse navbar-collapse" id="navigation">
        <ul class="navbar-nav mx-auto">
          <li class="nav-item">
            <a class="nav-link d-flex align-items-center me-2 active" aria-current="page" href="#about-usRes">
              Quiénes somos
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link me-2" href="#tabs">
              Tarifas
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link me-2" href="#Sostenibilidad">
              Sostenibilidad
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link me-2" href="#Security">
              Seguridad
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link me-2" href="#elpotosino">
              Parador
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link me-2" href=#contact-us>
              Contacto
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link me-2" href="https://facturacionquadrum.com.mx/valoran/#/login">
              Facturación
            </a>
          </li>
          <!-- <li class="nav-item">
              <a class="nav-link me-2" to="/signin">
                <img src="/waze.svg" width="30" alt="">
              </a>
            </li> -->
          <li class="nav-item" v-if="isLoggedIn">
            <div class="d-flex justify-content-start">
              <router-link class="nav-link fw-bold d-flex justify-content-start" :to="seleccionaRuta()">
                {{ getUserName.split(' ')[0] }} Panel
              </router-link>
              <a class=" nav-link fw-bold mx-0" href="" @click="logoutUser">
                Cerrar sesión
              </a>
            </div>
          </li>
          <li class="nav-item" v-else>
            <router-link class="nav-link fw-bold" to="/signin">
              Ingresar
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- End Navbar -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "nav-var-web",
  computed: {
    ...mapGetters('auth', ["getUserName", "isLoggedIn", "getUserRol"]),
  },
  methods: {
    ...mapActions('auth', ["logoutUser"]),
    seleccionaRuta() {
      switch (this.getUserRol) {
        case "Administrador":
          return '/users';
        case "Panel Web":
          return '/dashboard-default';
        case "Panel Auxilio Vial":
          return '/alerts';
        default:
          return '/meta';
      }
    }
  },
  props: {
    isBlur: String
  },
}
</script>